// import React, { useState, useMemo, useRef, useEffect } from 'react';
// import { ChevronLeft, Home, Zap, ShoppingCart, User, CheckCircle, Download, Check } from 'lucide-react';

// // Mock Data
// const selectedBiller = {
//     name: 'West Zone Power Distributor Company',
//     code: '1092',
//     logoText: 'WzPDC',
//     logoColor: 'text-blue-800',
//     logoBg: 'bg-blue-100',
//     mockBillNo: '0985251515623'
// };

// const mockBillDetails = {
//     billNo: '098525151562',
//     billMonthYear: '24-09-2025',
//     billAccount: '598.00 NGN',
//     dueDate: '24-09-2025',
//     currentBalance: '598.00 NGN',
//     amount: 500.00,
//     charge: 98.00,
//     total: 598.00
// };

// const mockTransaction = {
//     transactionId: '#71L69PJK3',
//     timestamp: new Date().toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true })
// };

// // Component for the Biller Card (used in all steps)
// const BillerCard = ({ biller }) => (
//     <div className="bg-white p-4 rounded-2xl shadow-md flex items-center mb-6">
//         <div className={`w-12 h-12 rounded-full flex items-center justify-center mr-4 font-bold text-sm ${biller.logoBg} ${biller.logoColor} ring-1 ring-inset ring-gray-200`}>
//             {biller.logoText}
//         </div>
//         <div>
//             <p className="text-gray-800 font-semibold">{biller.name}</p>
//             <p className="text-sm text-gray-500">{biller.code}</p>
//         </div>
//     </div>
// );

// // Component for displaying fetched bill information
// const BillDetailsSection = ({ details }) => (
//     <div className="bg-white p-5 rounded-2xl shadow-md mb-6">
//         <h2 className="text-sm font-bold text-gray-500 tracking-wider mb-3">BILL DETAILS</h2>
//         <div className="grid grid-cols-2 gap-y-4 text-sm">
//             <div className="text-gray-700 font-medium">
//                 Bill No
//                 <p className="text-base font-bold text-gray-900 mt-0.5">{details.billNo}</p>
//             </div>
//             <div className="text-gray-700 font-medium text-right">
//                 Bill Month Year
//                 <p className="text-base font-bold text-gray-900 mt-0.5">{details.billMonthYear}</p>
//             </div>
//             <div className="text-gray-700 font-medium">
//                 Bill Account
//                 <p className="text-base font-bold text-green-600 mt-0.5">{details.billAccount}</p>
//             </div>
//             <div className="text-gray-700 font-medium text-right">
//                 DUE Date
//                 <p className="text-base font-bold text-red-500 mt-0.5">{details.dueDate}</p>
//             </div>
//         </div>
//     </div>
// );

// // Transaction Row Helper Component (Moved outside App for correct definition order)
// const TransactionRow = ({ label, value, total = false }) => (
//     <div className="flex justify-between items-center text-sm">
//         <span className={`text-gray-600 ${total ? 'font-bold text-base' : ''}`}>{label}</span>
//         <span className={`text-gray-900 ${total ? 'font-extrabold text-lg' : 'font-medium'}`}>{value}</span>
//     </div>
// );


// // --- Main Application Component ---
// const PayEBillProviderDetails = ({ onBack, categoryId, categoryName, authToken }) => {
//     // Steps: 'input' (Bill No) -> 'details' (Bill Info) -> 'confirm' (Password/Hold) -> 'success'
//     const [step, setStep] = useState('input');
//     const [billNo, setBillNo] = useState(selectedBiller.mockBillNo);
//     const [password, setPassword] = useState('');
//     const [isHolding, setIsHolding] = useState(false);
//     const [holdProgress, setHoldProgress] = useState(0);
//     const [billDetails, setBillDetails] = useState(null);
//     const holdIntervalRef = useRef(null);

//     // --- Core Logic ---

//     // 1. Simulate fetching bill details (moves from 'input' to 'details')
//     const fetchBillDetails = () => {
//         if (billNo.length > 5) {
//             setTimeout(() => {
//                 setBillDetails(mockBillDetails);
//                 setStep('details');
//             }, 500);
//         }
//     };

//     // 2. Continue to Payment Confirmation (moves from 'details' to 'confirm')
//     const continueToConfirm = () => {
//         setStep('confirm');
//     };

//     // 3. Handle 'Tap and Hold' for payment confirmation
//     const handleMouseDown = (e) => {
//         e.preventDefault();
//         if (password.length > 0) {
//             setIsHolding(true);
//             setHoldProgress(0);

//             holdIntervalRef.current = setInterval(() => {
//                 setHoldProgress(prev => {
//                     const newProgress = prev + 10;
//                     if (newProgress >= 100) {
//                         clearInterval(holdIntervalRef.current);
//                         setIsHolding(false);
//                         setStep('success'); // Payment successful!
//                         return 100;
//                     }
//                     return newProgress;
//                 });
//             }, 100); // 10 intervals x 100ms = 1 second hold
//         }
//     };

//     const handleMouseUpOrLeave = () => {
//         if (holdIntervalRef.current) {
//             clearInterval(holdIntervalRef.current);
//             setHoldProgress(0);
//             setIsHolding(false);
//         }
//     };

//     // Cleanup interval on component unmount
//     useEffect(() => {
//         return () => {
//             if (holdIntervalRef.current) {
//                 clearInterval(holdIntervalRef.current);
//             }
//         };
//     }, []);


//     // --- View Content Management ---

//     const content = useMemo(() => {
//         if (step === 'input') {
//             // --- Screen 1: Bill No Input ---
//             return (
//                 <>
//                     <BillerCard biller={selectedBiller} />

//                     <label htmlFor="bill-no" className="block text-lg font-semibold text-gray-800 mb-2">
//                         Bill No
//                     </label>
//                     <input
//                         id="bill-no"
//                         type="tel"
//                         placeholder="Enter Bill Number"
//                         value={billNo}
//                         onChange={(e) => setBillNo(e.target.value)}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition duration-150 text-gray-800 text-lg font-medium"
//                     />
//                 </>
//             );
//         }

//         if (step === 'details') {
//             // --- Screen 2: Bill Details Display ---
//             return (
//                 <>
//                     <BillerCard biller={selectedBiller} />

//                     <BillDetailsSection details={mockBillDetails} />

//                     <label htmlFor="bill-no-details" className="block text-lg font-semibold text-gray-800 mb-2">
//                         Bill No
//                     </label>
//                     <input
//                         id="bill-no-details"
//                         type="text"
//                         readOnly
//                         value={billNo}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl bg-gray-50 text-gray-800 text-lg font-medium select-none"
//                     />
//                     <p className="text-sm text-gray-500 mt-2 flex items-center">
//                         <CheckCircle className="w-4 h-4 text-green-500 mr-1.5" />
//                         Current Balance {mockBillDetails.currentBalance}
//                     </p>
//                 </>
//             );
//         }

//         if (step === 'confirm') {
//             // --- Screen 3: Payment Confirmation (Password) ---
//             return (
//                 <>
//                     <BillerCard biller={selectedBiller} />

//                     {/* Amount & Due Date Card (from image 3) */}
//                     <div className="bg-white p-5 rounded-2xl shadow-md mb-6">
//                         <div className="flex justify-between items-center mb-1">
//                             <p className="text-xl font-bold text-red-600">
//                                 {mockBillDetails.billAccount}
//                             </p>
//                             <p className="text-sm font-medium text-gray-700">
//                                 DUE Date
//                             </p>
//                         </div>
//                         <div className="flex justify-between items-center">
//                             <p className="text-xs text-red-500">* Include Charges</p>
//                             <p className="text-base font-bold text-gray-900">
//                                 {mockBillDetails.dueDate}
//                             </p>
//                         </div>
//                     </div>

//                     <label htmlFor="password" className="block text-lg font-semibold text-gray-800 mb-2 mt-4">
//                         Password
//                     </label>
//                     <input
//                         id="password"
//                         type="password"
//                         placeholder="Enter your password"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         className="w-full px-4 py-3 border border-gray-300 rounded-xl bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition duration-150 text-gray-800 text-lg font-medium"
//                     />
//                 </>
//             );
//         }

//         if (step === 'success') {
//             // --- Screen 4: Success Message ---
//             return (
//                 <div className="p-5">
//                     <div className="bg-white p-6 rounded-2xl shadow-xl text-center">
//                         <div className="w-20 h-20 mx-auto bg-blue-100 rounded-full flex items-center justify-center mb-4">
//                             <Check className="w-10 h-10 text-blue-600 stroke-[3]" />
//                         </div>
//                         <h2 className="text-2xl font-bold text-gray-800">Bill Pay Successful</h2>
//                         <p className="text-gray-500 mt-1 mb-6">DESCO Postpaid (Mock Biller)</p>

//                         <div className="space-y-4 pt-4 border-t border-gray-100">
//                             {/* Transaction Details */}
//                             <TransactionRow label="Transaction ID" value={mockTransaction.transactionId} />
//                             <TransactionRow label="Amount" value={`${mockBillDetails.amount.toFixed(2)} NGN`} />
//                             <TransactionRow label="Charge" value={`${mockBillDetails.charge.toFixed(2)} NGN`} />
//                             <TransactionRow label="Total" value={`${mockBillDetails.total.toFixed(2)} NGN`} total />
//                             <TransactionRow label="Timestamp" value={mockTransaction.timestamp} />
//                         </div>

//                         <button className="mt-8 flex items-center justify-center mx-auto text-blue-600 font-semibold hover:text-blue-700 transition">
//                             <Download className="w-5 h-5 mr-2" />
//                             Download Invoice
//                         </button>
//                     </div>
//                 </div>
//             );
//         }
//     }, [step, billNo, password, isHolding]);

//     // Dynamic Footer Button properties
//     const footerButton = useMemo(() => {
//         if (step === 'input') {
//             return {
//                 text: 'Next',
//                 onClick: fetchBillDetails,
//                 disabled: billNo.length < 5,
//             };
//         } else if (step === 'details') {
//             return {
//                 text: 'Continue to Payment',
//                 onClick: continueToConfirm,
//                 disabled: false,
//             };
//         } else if (step === 'confirm') {
//             // Button is handled by mouse events
//             return {
//                 text: isHolding ? `Processing... (${holdProgress}%)` : 'TAP AND HOLD TO CONFIRM',
//                 onClick: () => { }, // Click does nothing, hold triggers action
//                 isHold: true,
//                 disabled: password.length === 0,
//             };
//         } else if (step === 'success') {
//             return {
//                 text: 'Back To Home',
//                 onClick: () => setStep('input'), // Reset flow
//                 disabled: false,
//             };
//         }
//     }, [step, billNo, password, isHolding, holdProgress]);

//     // Handle Back Button logic
//     const handleBack = () => {
//         if (step === 'input') {
//             onBack()
//         }
//         if (step === 'details') {
//             setStep('input');
//         }
//         else if (step === 'confirm') {
//             setPassword('');
//             setStep('details');
//         } else if (step === 'success') {
//             // On success, back button behavior is usually 'Home' or disabled. 
//             // We'll mimic 'Back To Home' or ignore it here.
//             setStep('input');
//         } else {
//             console.log("Going back to Biller selection.");
//         }
//     }


//     return (
//         // <div className="min-h-screen bg-gray-100 p-4 sm:p-0">
//             <div className="max-w-md mx-auto min-h-screen bg-white shadow-xl flex flex-col rounded-xl sm:rounded-none">

//                 {/* Header */}
//                 <header className="flex items-center p-4 border-b border-gray-200 sticky top-0 bg-white z-10">
//                     <button
//                         className="text-gray-600 hover:text-blue-500 transition disabled:opacity-50"
//                         onClick={handleBack}
//                         disabled={step === 'success'} // Often disabled on success screen
//                     >
//                         <ChevronLeft className="w-6 h-6" />
//                     </button>
//                     <h1 className="flex-grow text-center text-lg font-semibold text-gray-800">Pay electricity</h1>
//                     <div className="w-6 h-6"></div>
//                 </header>

//                 {/* Scrollable Content Area */}
//                 {/* Adjust padding for the success screen as it contains a card with its own padding */}
//                 <main className={`flex-grow overflow-y-auto ${step !== 'success' ? 'p-5' : 'py-5'}`}>
//                     {content}
//                 </main>

//                 {/* Fixed Footer Action and Navigation */}
//                 <div className="sticky bottom-0 bg-white z-20 shadow-lg">
//                     {/* Action Button */}
//                     <div className="p-4 border-t border-gray-100">
//                         {footerButton.isHold ? (
//                             <div
//                                 className={`w-full py-3 rounded-xl font-semibold text-lg shadow-lg transition duration-200 relative overflow-hidden cursor-pointer select-none 
//                                     ${footerButton.disabled
//                                         ? 'bg-blue-300 text-white cursor-not-allowed'
//                                         : 'bg-blue-600 text-white hover:bg-blue-700 active:scale-[0.99]'
//                                     }`}
//                                 onMouseDown={!footerButton.disabled ? handleMouseDown : undefined}
//                                 onMouseUp={!footerButton.disabled ? handleMouseUpOrLeave : undefined}
//                                 onMouseLeave={!footerButton.disabled ? handleMouseUpOrLeave : undefined}
//                                 onTouchStart={!footerButton.disabled ? handleMouseDown : undefined}
//                                 onTouchEnd={!footerButton.disabled ? handleMouseUpOrLeave : undefined}
//                                 onTouchCancel={!footerButton.disabled ? handleMouseUpOrLeave : undefined}
//                             >
//                                 {/* Progress Overlay */}
//                                 <div
//                                     className="absolute inset-0 bg-blue-700 opacity-50 transition-all duration-100 ease-linear flex justify-center items-center"
//                                     style={{ width: `${holdProgress}%` }}
//                                 ></div>
//                                 <span className="relative z-10 flex justify-center items-center">{footerButton.text}</span>
//                             </div>
//                         ) : (
//                             <button
//                                 onClick={footerButton.onClick}
//                                 disabled={footerButton.disabled}
//                                 className={`w-full py-3 rounded-xl font-semibold text-lg shadow-lg transition duration-200 
//                                     ${footerButton.disabled
//                                         ? 'bg-blue-300 cursor-not-allowed'
//                                         : 'bg-blue-600 text-white hover:bg-blue-700'
//                                     }`}
//                             >
//                                 {footerButton.text}
//                             </button>
//                         )}
//                     </div>

//                     {/* Navigation Bar */}
//                     {/* <nav className="border-t border-gray-200 py-2.5">
//                         <div className="flex justify-around items-center h-16">
//                             <a href="#" className="flex flex-col items-center text-gray-400 hover:text-blue-500 transition duration-150">
//                                 <Home className="w-6 h-6" />
//                                 <span className="text-xs mt-0.5">Home</span>
//                             </a>
//                             <a href="#" className="flex flex-col items-center text-blue-500 transition duration-150">
//                                 <Zap className="w-6 h-6" />
//                                 <span className="text-xs mt-0.5">Energy</span>
//                             </a>
//                             <a href="#" className="flex flex-col items-center text-gray-400 hover:text-blue-500 transition duration-150">
//                                 <ShoppingCart className="w-6 h-6" />
//                                 <span className="text-xs mt-0.5">Cart</span>
//                             </a>
//                             <a href="#" className="flex flex-col items-center text-gray-400 hover:text-blue-500 transition duration-150">
//                                 <User className="w-6 h-6" />
//                                 <span className="text-xs mt-0.5">Profile</span>
//                             </a>
//                         </div>
//                         <div className="h-1 w-24 mx-auto bg-gray-300 rounded-full mt-1"></div>
//                     </nav> */}
//                 </div>
//             </div>
//         // </div>

//     );
// };


// export default PayEBillProviderDetails;



import React, { useState, useMemo, useRef, useEffect, useCallback } from 'react';
import { ChevronLeft, Check, Loader2, CheckCircle, Download, ChevronRight } from 'lucide-react';

import { Copy } from "lucide-react";
import { useCapacitorBackHandler } from '../../hooks/billbackHandler';
import { InterswitchPay } from 'react-interswitch';
import { API_BASE_URL } from '../../config/api';

const BILLER_API_BASE_URL = `${API_BASE_URL}/utility-transactions/charges`;
const PAY_BILL_API_URL = `${API_BASE_URL}/utility-transactions/settle`
// --- Helper Components (Kept the same) ---

// Component for the Biller Card (used in all steps)
const BillerCard = ({ biller }) => (
    <div className="bg-white p-4 rounded-2xl shadow-md flex items-center mb-6">
        <div className={`w-12 h-12 rounded-full flex items-center justify-center mr-4 font-bold text-sm bg-blue-100 text-blue-800 ring-1 ring-inset ring-gray-200`}>
            {biller.logoText}
        </div>
        <div>
            <p className="text-gray-800 font-semibold">{biller.name}</p>
            <p className="text-sm text-gray-500">{biller.code}</p>
        </div>
    </div>
);

// Component for displaying fetched bill information
const BillDetailsSection = ({ details }) => (
    <div className="bg-white p-5 rounded-2xl shadow-md mb-6">
        <h2 className="text-sm font-bold text-gray-500 tracking-wider mb-3">BILL DETAILS</h2>
        <div className="grid grid-cols-2 gap-y-4 text-sm">
            {/* <div className="text-gray-700 font-medium">
                Service Name
                <p className="text-base font-bold text-gray-900 mt-0.5">{details.Name}</p>
            </div>
            <div className="text-gray-700 font-medium text-right">
                Bill No
                <p className="text-base font-bold text-gray-900 mt-0.5">{details.PaymentCode}</p>
            </div> */}
            <div className="text-gray-700 font-medium">
                Base Amount
                <p className="text-base font-bold text-green-600 mt-0.5">{`${parseFloat(details.Amount / 100).toFixed(2)} NGN`}</p>
            </div>
            <div className="text-gray-700 font-medium text-right">
                Item Fee (Charge)
                <p className="text-base font-bold text-red-500 mt-0.5">{`${parseFloat(details.ItemFee / 100).toFixed(2)} NGN`}</p>
            </div>
            <div className="col-span-2 border-t mt-4 pt-3 flex justify-between items-center">
                <p className="text-lg font-bold text-gray-900">Total Payable</p>
                <p className="text-xl font-extrabold text-blue-600">
                    {`${(parseFloat(details.Amount / 100) + parseFloat(details.ItemFee / 100)).toFixed(2)} NGN`}
                </p>
            </div>
        </div>
    </div>
);


// Transaction Row Helper Component
// const TransactionRow = ({ label, value, total = false }) => (
//     <div className="flex justify-between items-center text-sm">
//         <span className={`text-gray-600 ${total ? 'font-bold text-base' : ''}`}>{label}</span>
//         <span className={`text-gray-900 ${total ? 'font-extrabold text-lg' : 'font-medium'}`}>{value}</span>
//     </div>
// );


const TransactionRow = ({ label, value, total = false, copyable = false }) => {
    // Shorten long values (e.g., transaction IDs)
    const shorten = (text) => {
        if (!text || text.length <= 15) return text;
        return text.substring(0, 8) + "..." + text.substring(text.length - 5);
    };

    // Copy to clipboard
    const handleCopy = () => {
        navigator.clipboard.writeText(value);
    };

    return (
        <div className="flex justify-between items-center text-sm">
            <span className={`text-gray-600 ${total ? 'font-bold text-base' : ''}`}>
                {label}
            </span>

            <div className="flex items-center gap-2">
                <span className={`text-gray-900 ${total ? 'font-extrabold text-lg' : 'font-medium'}`}>
                    {copyable ? shorten(value) : value}
                </span>

                {copyable && (
                    <Copy
                        className="w-4 h-4 text-blue-500 cursor-pointer hover:text-blue-700"
                        onClick={handleCopy}
                    />
                )}
            </div>
        </div>
    );
};



// --- Main Application Component (MODIFIED) ---
const PayEBillProviderDetails = ({ onBack, authToken, billerName, billerId, categoryName,userSession }) => {



    const biller = useMemo(() => ({
        name: billerName || 'Selected Biller',
        code: billerId || '0000',
        logoText: billerName ? billerName.substring(0, 5).toUpperCase() : 'BILL',
    }), [billerName, billerId]);

    // Mock Transaction Data (used for success screen)
    const mockTransaction = useMemo(() => ({
        transactionId: `#71L${Math.floor(Math.random() * 90000) + 10000}P`,
        timestamp: new Date().toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true })
    }), []);

    // States
    const [step, setStep] = useState('input');
    // Store the raw list of charges/services
    const [availableCharges, setAvailableCharges] = useState([]);
    // Store the full selected charge object
    const [selectedCharge, setSelectedCharge] = useState(null);
    const [paymentResult, setPaymentResult] = useState(null);

    // Payment-related states
    const [password, setPassword] = useState('');
    const [isHolding, setIsHolding] = useState(false);
    const [holdProgress, setHoldProgress] = useState(0);

    const [isLoading, setIsLoading] = useState(true); // Start loading immediately to fetch charges
    const [error, setError] = useState(null);


    const [userAmount, setUserAmount] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("2348056731576");

    const holdIntervalRef = useRef(null);

    // --- Core Logic ---


    const [isProcessing, setIsProcessing] = useState(false);
const [paymentData, setPaymentData] = useState(null);
const [serverError, setServerError] = useState(null);
    // 1. Fetch the list of available charges (runs on load)
    const fetchAvailableCharges = useCallback(async () => {
        console.log("Fetching charges for Biller ID:", billerId, "at URL:", BILLER_API_BASE_URL);

        if (!authToken || !billerId) {
            setError('Missing authentication token or biller ID.');
            setIsLoading(false);
            return;
        }

        // Reset previous states
        setAvailableCharges([]);
        setError(null);
        setIsLoading(true);

        try {
            const URL = `${BILLER_API_BASE_URL}/${billerId}`;
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ message: 'Server error' }));
                throw new Error(`Failed to fetch charges: ${errorData.message || response.statusText}`);
            }

            const result = await response.json();

            if (result.status !== "SUCCESS" || !result.data || !Array.isArray(result.data.charges)) {
                throw new Error(result.message || 'Invalid or empty list of charges returned.');
            }

            setAvailableCharges(result.data.charges);
            setStep('input'); // Ensure we stay on the input/selection screen

        } catch (e) {
            console.error("API Fetch Error:", e);
            setError(e.message);
            setStep('input');
        } finally {
            setIsLoading(false);
        }
    }, [authToken, billerId]);


    // Runs only once on component mount to load the service list
    useEffect(() => {
        fetchAvailableCharges();
    }, [fetchAvailableCharges]);


    // 2. Handle selection of a charge (This is the user's "Next" step)
    const handleSelectCharge = (charge) => {
        // Set the full object of the selected charge
        setSelectedCharge(charge);
        // Move to the details screen to review the selected service
        setStep('details');
    };



    // 3. Continue to Payment Confirmation (moves from 'details' to 'confirm')
    const continueToConfirm = () => {
        if (selectedCharge) {
            setStep('confirm');
        } else {
            setError('Please select a service first.');
            setStep('input');
        }
    };

    // -----------------------------
    // TAP & HOLD → CALL PAYMENT API
    // -----------------------------
    // const handleMakePayment = async () => {
    //     try {
    //         setIsLoading(true);
    //         setError(null);

    //         // API request body (matches your requirement)
    //         const body = {
    //             category: categoryName,
    //             biller: biller.name,
    //             charge: selectedCharge.PaymentCode,
    //             amount: `${userAmount * 100}`,
    //             phone: phoneNumber

    //         }

    //         const response = await fetch(PAY_BILL_API_URL, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 "Authorization": `Bearer ${authToken}`
    //             },
    //             body: JSON.stringify(body)
    //         });

    //         const result = await response.json();

    //         if (!response.ok || result.status !== "SUCCESS") {
    //             throw new Error(result.message || "Payment failed");
    //         }

    //         const paymentData = result.data.transaction;
    //         const successData = {
    //             id: paymentData.id,
    //             provider: paymentData.provider,
    //             serviceName: paymentData.reference.ServiceName,
    //             invoice: paymentData.invoice,
    //             status: paymentData.status.label,

    //             // MAIN MONEY FIELDS
    //             amount: Number(paymentData.amount) / 100,              // Main amount in NGN
    //             approvedAmount: Number(paymentData.reference.ApprovedAmount) / 100,
    //             surcharge: Number(paymentData.reference.Surcharge || 0) / 100, // Add surcharge safely

    //             totalAmount:
    //                 (Number(paymentData.amount) / 100) +
    //                 (Number(paymentData.reference.Surcharge || 0) / 100),

    //             // OTHER FIELDS
    //             phone: paymentData.reference.CustomerMobile,
    //             referenceId: paymentData.reference.id,
    //             paymentDate: paymentData.reference.PaymentDate,
    //             method: paymentData.method.label,
    //             recharge: paymentData.reference.Recharge
    //         };

    //         setPaymentResult(successData);
    //         setStep("success");

    //     } catch (err) {
    //         setError(err.message);
    //         setStep("confirm");
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };

    const VERIFY_API_BASE = `${API_BASE_URL}/payments`;

    const handleInterswitchCallback = async (response) => {
        console.log("Interswitch Response:", response);

        if (response.resp !== "00") {
            alert("Payment failed or cancelled.");
            setIsProcessing(false);
            setPaymentData(null);
            return;
        }

        try {
            const verifyResponse = await fetch(
                `${VERIFY_API_BASE}/${paymentData.paymentId}/verify`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${authToken}`,
                    },
                }
            );

            const verificationResult = await verifyResponse.json();

            if (verifyResponse.ok && verificationResult.status === "SUCCESS") {
                const paymentDetails = verificationResult.data.payment;

                const successData = {
                    id: paymentDetails.id,
                    amount: paymentDetails.amount,
                    surcharge: paymentDetails.reference?.Surcharge || 0,
                    totalAmount:
                        Number(paymentDetails.amount) +
                        Number(paymentDetails.reference?.Surcharge || 0),
                    paymentDate: paymentDetails.reference?.TransactionDate,
                };

                setPaymentResult(successData);
                setStep("success");
            } else {
                alert("Verification failed.");
            }
        } catch (err) {
            alert("Verification network error.");
        }

        setIsProcessing(false);
        setPaymentData(null);
    };
    const handleCreateBillPayment = async () => {
    try {
        if (isProcessing || paymentData) return;

        setIsProcessing(true);
        setServerError(null);

        const body = {
            category: categoryName,
            biller: biller.name,
            charge: selectedCharge.PaymentCode,
            amount: userAmount,
            phone: phoneNumber
        };

        const response = await fetch(PAY_BILL_API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify(body)
        });

        const result = await response.json();

        if (!response.ok || result.status !== "SUCCESS") {
            throw new Error(result.message || "Payment setup failed");
        }

        const paymentInfo = result.data?.payment || {};
        const paymentRef = paymentInfo.reference || {};

        // 🔥 STORE interswitch data
        setPaymentData({
            paymentId: paymentInfo.id,
            transactionReference: paymentRef.id,
            amount: String(parseFloat(paymentInfo.amount) * 100),
            merchantCode: paymentRef.merchant,
            payItemId: paymentRef.charge,
            mode: paymentRef.mode,
        });

    } catch (err) {
        setServerError(err.message);
        setIsProcessing(false);
    }
};

    const interswitchParams = paymentData
        ? {
            merchantCode: paymentData.merchantCode,
            payItemID: paymentData.payItemId,
            customerEmail: userSession.email,
            redirectURL: window.location.origin,
            mode: paymentData.mode,
            text: "Proceed to Payment Gateway",
            transactionReference: paymentData.transactionReference,
            amount: paymentData.amount,
            callback: handleInterswitchCallback,
        }
        : null;


        

   
    useEffect(() => {
        if (selectedCharge) {
            const converted = (parseFloat(selectedCharge.Amount) / 100).toFixed(2);
            setUserAmount(converted);
        }
    }, [selectedCharge]);


    const validateAmount = (value) => {
        if (!selectedCharge) return false;

        const returnedAmount = parseFloat(selectedCharge.Amount) / 100;

        const userVal = parseFloat(value);
        const type = Number(selectedCharge.AmountType);

        if (isNaN(userVal)) return false;
        if (userVal <= 0) return false;

        switch (type) {
            case 0:
                // ANY amount allowed
                return userVal > 0;

            case 1:
                // MINIMUM → user >= returnedAmount
                return userVal >= returnedAmount;

            case 2:
                // > MINIMUM → user > returnedAmount
                return userVal > returnedAmount;

            case 3:
                // MAXIMUM → user ≤ returnedAmount
                return userVal <= returnedAmount;

            case 4:
                // < MAXIMUM → user < returnedAmount
                return userVal < returnedAmount;

            case 5:
                // EXACT → must match
                return userVal === returnedAmount;

            default:
                return false;
        }
    };



    // Cleanup interval on component unmount
    useEffect(() => {
        return () => {
            if (holdIntervalRef.current) {
                clearInterval(holdIntervalRef.current);
            }
        };
    }, []);


    // --- View Content Management ---

    const content = useMemo(() => {
        if (isLoading) {
            // --- Loading Screen ---
            return (
                <div className="flex flex-col items-center justify-center p-10 h-64">
                    <Loader2 className="w-8 h-8 text-blue-500 animate-spin mb-4" />
                    <p className="text-gray-600 font-medium">Fetching Available Services...</p>
                </div>
            );
        }

        if (step === 'input') {
            // --- Screen 1: Select Bill/Charge Option ---
            return (
                <>
                    {error && (
                        <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-xl mb-6">
                            <p className="font-bold">Error!</p>
                            <p className="text-sm">{error}</p>
                        </div>
                    )}
                    <BillerCard biller={biller} />

                    <h2 className="text-lg font-semibold text-gray-800 mb-4">Select a Bill No:</h2>

                    {availableCharges.length > 0 ? (
                        <div className="space-y-3">
                            {availableCharges.map((charge) => (
                                <button
                                    key={charge.PaymentCode}
                                    onClick={() => handleSelectCharge(charge)}
                                    className="w-full text-left p-4 bg-white rounded-xl shadow-sm border border-gray-200 hover:border-blue-500 transition duration-150 flex justify-between items-center"
                                >
                                    <div>
                                        <p className="font-semibold text-gray-800"> Bill No: {charge.PaymentCode}</p>
                                        <p className="text-xs text-gray-500 mt-1">
                                            {charge.Name}
                                        </p>
                                    </div>
                                    <ChevronRight className="w-5 h-5 text-blue-500" />
                                </button>
                            ))}
                        </div>
                    ) : (
                        <div className="p-6 text-center text-gray-500 bg-gray-50 rounded-xl">
                            No services available for this biller.
                        </div>
                    )}
                </>
            );
        }

        if (step === 'details') {
            // --- Screen 2: Bill Details Display ---
            if (!selectedCharge) return null;
            return (
                <>
                    <BillerCard biller={biller} />

                    {/* Using the updated BillDetailsSection which supports the new API structure */}
                    <BillDetailsSection details={selectedCharge} />

                    <div className="p-4 bg-blue-50 border border-blue-200 text-blue-700 rounded-xl mt-6">
                        <p className="font-bold">Consumer ID:</p>
                        <p className="text-sm">{selectedCharge.ConsumerIdField}</p>
                    </div>
                </>
            );
        }

        if (step === 'confirm') {
            // --- Screen 3: Payment Confirmation (Password) ---
            if (!selectedCharge) return null;

            const totalAmount = parseFloat(selectedCharge.Amount) + parseFloat(selectedCharge.ItemFee);

            return (
                <>
                    <BillerCard biller={biller} />

                    {/* Amount & Due Date Card (Using calculated total) */}
                    <div className="bg-white p-5 rounded-2xl shadow-md mb-6">
                        <div className="flex justify-between items-center mb-1">
                            <p className="text-xl font-bold text-red-600">
                                {`${(totalAmount / 100).toFixed(2)} NGN`}
                            </p>
                            <p className="text-sm font-medium text-gray-700">
                                DUE Date
                            </p>
                        </div>
                        <div className="flex justify-between items-center">
                            <p className="text-xs text-red-500">* Includes Fee/Charge: {parseFloat(selectedCharge.ItemFee / 100).toFixed(2)} NGN</p>
                            <p className="text-base font-bold text-gray-900">
                                N/A
                            </p>
                        </div>
                    </div>
                    {/* AMOUNT INPUT FIELD */}
                    {/* PAY AMOUNT FIELD */}

                    <div className="mb-5">
                        <label htmlFor="phoneNumber" className="block text-lg font-semibold text-gray-800 mb-2">
                            Phone Number
                        </label>
                        <input
                            id="phoneNumber"
                            type="tel" // Use type="tel" for mobile numbers
                            placeholder="e.g., 08012345678"
                            value={phoneNumber} // Assume 'phoneNumber' state exists
                            onChange={(e) => setPhoneNumber(e.target.value)} // Assume 'setPhoneNumber' function exists
                            className="w-full px-4 py-3 border border-gray-300 rounded-xl bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition duration-150 text-gray-800 text-lg font-medium"
                        />
                    </div>
                    <div className="mb-5">
                        <label className="block text-lg font-semibold text-gray-800 mb-2">
                            Pay Amount (NGN)
                        </label>

                        <input
                            type="number"
                            value={userAmount}
                            disabled={Number(selectedCharge.AmountType) === 5}  // Exact → disable editing
                            onChange={(e) => setUserAmount(e.target.value)}
                            className={`w-full px-4 py-3 border rounded-xl bg-white text-lg font-medium outline-none
            ${validateAmount(userAmount)
                                    ? "border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                    : "border-red-500 ring-red-300"
                                }`}
                        />

                        {!validateAmount(userAmount) && (
                            <p className="text-red-500 text-sm mt-1">
                                Amount does not meet biller rules for this service.
                            </p>
                        )}
                    </div>

                </>
            );
        }

        if (step === 'success') {
            // --- Screen 4: Success Message ---
            if (!selectedCharge) return null;

            const amount = parseFloat(selectedCharge.Amount);
            const charge = parseFloat(selectedCharge.ItemFee);
            const total = amount + charge;

            return (
                <div className="p-5">
                    <div className="bg-white p-6 rounded-2xl shadow-xl text-center">
                        <div className="w-20 h-20 mx-auto bg-blue-100 rounded-full flex items-center justify-center mb-4">
                            <Check className="w-10 h-10 text-blue-600 stroke-[3]" />
                        </div>
                        <h2 className="text-2xl font-bold text-gray-800">Bill Pay Successful</h2>
                        <p className="text-gray-500 mt-1 mb-6">{biller.name} - {selectedCharge.Name}</p>

                        <div className="space-y-4 pt-4 border-t">
                            {/* <TransactionRow label="Transaction ID" value={paymentResult.transactionid} />
                             <TransactionRow label="Amount" value={`${paymentResult.amount/100} NGN`} />
                            <TransactionRow label="Charge" value={`${paymentResult.fee} NGN`} />
                            <TransactionRow label="Total" value={`${paymentResult.totalAmount} NGN`} total />
                            <TransactionRow label="Timestamp" value={paymentResult.} /> */}

                            <TransactionRow
                                label="Transaction ID"
                                value={paymentResult.id}
                                copyable
                            />

                            <TransactionRow
                                label="Amount"
                                value={`${paymentResult.amount} NGN`}
                            />

                            <TransactionRow
                                label="Charge"
                                value={`${paymentResult.surcharge} NGN`}
                            />

                            <TransactionRow
                                label="Total"
                                value={`${paymentResult.totalAmount} NGN`}
                                total
                            />

                            <TransactionRow
                                label="Timestamp"
                                value={paymentResult.paymentDate}
                            />



                        </div>

                        <button className="mt-8 flex items-center justify-center mx-auto text-blue-600 font-semibold hover:text-blue-700 transition">
                            <Download className="w-5 h-5 mr-2" />
                            Download Invoice
                        </button>
                    </div>
                </div>
            );
        }
        return null;
    }, [step, password, isHolding, isLoading, error, selectedCharge, availableCharges, biller, mockTransaction, handleSelectCharge]);

    // Dynamic Footer Button properties 
    const footerButton = useMemo(() => {
        if (isLoading) {
            return { text: 'Loading Services...', onClick: () => { }, disabled: true };
        }
        if (step === 'input') {
            // No need for a button here, selection is done by clicking the list item
            return { text: `Select a Bill No)`, onClick: () => { }, disabled: true };
        } else if (step === 'details') {
            return {
                text: 'Continue to Payment',
                onClick: continueToConfirm,
                disabled: false,
            };

        }
        // else if (step === 'confirm') {
        //     return {
        //         text: isLoading ? 'Processing...' : 'Proceed to Payment',
        //         onClick: handleMakePayment,
        //         disabled: isLoading || !validateAmount(userAmount),
        //     };


        // }

        else if (step === 'confirm') {
            // 🔥 SHOW INTERSWITCH BUTTON
            if (paymentData && interswitchParams) {
                return {
                    custom: (
                        <InterswitchPay
                            {...interswitchParams}
                            style={{
                                width: '100%',
                                height: '48px',
                                border: 'none',
                                color: '#fff',
                                backgroundColor: '#2563EB',
                                borderRadius: '12px',
                                fontWeight: '600',
                                fontSize: '16px',
                                cursor: 'pointer',
                            }}
                        />
                    )
                };
            }

            // 🔥 FIRST BUTTON
            return {
                text: isProcessing ? 'Preparing Payment...' : 'Proceed to Payment',
                onClick: handleCreateBillPayment,
                disabled: isProcessing || !validateAmount(userAmount),
            };
        }
        else if (step === 'success') {
            return {
                text: 'Back To Home',
                onClick: () => onBack(),
                disabled: false,
            };
        }
        return { text: 'Wait...', onClick: () => { }, disabled: true };
    }, [step, password, isHolding, holdProgress, isLoading, availableCharges.length, continueToConfirm, onBack]);

    // Handle Back Button logic
    const handleBack = () => {
        if (step === 'input') {
            onBack()
        }
        else if (step === 'details') {
            // Go back to the selection list
            setSelectedCharge(null);
            setStep('input');
        }
        else if (step === 'confirm') {
            setPassword('');
            setStep('details');
        } else if (step === 'success') {
            onBack();
        }
    }

    useCapacitorBackHandler(handleBack);


    return (
        <div className="max-w-md mx-auto min-h-screen bg-white shadow-xl flex flex-col rounded-xl sm:rounded-none">



            <header className="flex items-center p-4 border-b border-gray-200 bg-white z-20 w-full max-w-md mx-auto">
                <button
                    className="text-gray-600 hover:text-blue-500 transition disabled:opacity-50"
                    onClick={handleBack}
                    disabled={step === 'success' || isLoading}
                    hidden={step === 'success'}
                >
                    <ChevronLeft className="w-6 h-6" />
                </button>
                <h1 className="flex-grow text-center text-lg font-semibold text-gray-800">   Pay {categoryName || 'Bill'}</h1>
                <div className="w-6 h-6"></div>
            </header>

            {/* Scrollable Content Area */}
            <main className={`flex-grow overflow-y-auto ${step !== 'success' && !isLoading ? 'p-5' : 'py-5'}`}>
                {content}
            </main>

            {/* <div className="sticky bottom-0 bg-white z-20 shadow-lg"> */}
            {/* Fixed Footer Action */}
            {(
                <div className="fixed bottom-0 inset-x-0 z-30 shadow-2xl bg-white">
                    {/* <div className="p-4 border-t border-gray-100">


                        <button
                            onClick={footerButton.onClick}
                            disabled={footerButton.disabled}
                            className={`w-full py-3 rounded-xl font-semibold text-lg shadow-lg transition duration-200
    ${footerButton.disabled
                                    ? 'bg-blue-300 text-white cursor-not-allowed'
                                    : 'bg-blue-600 text-white hover:bg-blue-700'
                                }`}
                        >
                            {footerButton.text}
                        </button>
                    </div> */}
                    <div className="p-4 border-t border-gray-100">
    {footerButton.custom ? (
        footerButton.custom
    ) : (
        <button
            onClick={footerButton.onClick}
            disabled={footerButton.disabled}
            className={`w-full py-3 rounded-xl font-semibold text-lg shadow-lg transition duration-200
                ${footerButton.disabled
                    ? 'bg-blue-300 text-white cursor-not-allowed'
                    : 'bg-blue-600 text-white hover:bg-blue-700'
                }`}
        >
            {footerButton.text}
        </button>
    )}
</div>
                </div>
            )}
        </div>
    );
};


export default PayEBillProviderDetails;




// const PayEBillProviderDetails = ({ onBack, authToken, billerName, billerId }) => {
//     // -----------------------------
//     // BASIC BILLER DETAILS
//     // -----------------------------
//     const biller = useMemo(() => ({
//         name: billerName || "Selected Biller",
//         code: billerId || "0000",
//         logoText: billerName ? billerName.substring(0, 5).toUpperCase() : "BILL",
//     }), [billerName, billerId]);

//     // -----------------------------
//     // STATES
//     // -----------------------------
//     const [step, setStep] = useState("input");
//     const [availableCharges, setAvailableCharges] = useState([]);
//     const [selectedCharge, setSelectedCharge] = useState(null);

//     // Payment flow states
//     const [password, setPassword] = useState("");
//     const [holdProgress, setHoldProgress] = useState(0);
//     const [isHolding, setIsHolding] = useState(false);

//     const [paymentResult, setPaymentResult] = useState(null);

//     // misc
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const holdIntervalRef = useRef(null);

//     // -----------------------------
//     // FETCH AVAILABLE CHARGES
//     // -----------------------------
//     const fetchAvailableCharges = useCallback(async () => {
//         if (!authToken || !billerId) {
//             setError("Missing authentication token or biller ID.");
//             setIsLoading(false);
//             return;
//         }

//         setIsLoading(true);
//         setError(null);

//         try {
//             const URL = `${BILLER_API_BASE_URL}/${billerId}`;
//             const response = await fetch(URL, {
//                 method: "GET",
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Authorization": `Bearer ${authToken}`,
//                 },
//             });

//             const result = await response.json();

//             if (!response.ok || result.status !== "SUCCESS") {
//                 throw new Error(result.message || "Invalid response from server");
//             }

//             if (!result.data?.charges || !Array.isArray(result.data.charges)) {
//                 throw new Error("No valid charge items returned.");
//             }

//             setAvailableCharges(result.data.charges);
//             setStep("input");

//         } catch (e) {
//             setError(e.message);
//             setStep("input");
//         } finally {
//             setIsLoading(false);
//         }
//     }, [authToken, billerId]);

//     useEffect(() => {
//         fetchAvailableCharges();
//     }, [fetchAvailableCharges]);

//     // -----------------------------
//     // TAP & HOLD → CALL PAYMENT API
//     // -----------------------------
//     const handleMakePayment = async () => {
//         try {
//             setIsLoading(true);
//             setError(null);

//             const body = {
//                 category: "Utility Bills",
//                 biller: biller.name,
//                 charge: selectedCharge.PaymentCode,
//                 amount: selectedCharge.Amount,
//                 phone: "2348056731576"
//             };

//             const response = await fetch(PAY_BILL_API_URL, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Authorization": `Bearer ${authToken}`
//                 },
//                 body: JSON.stringify(body)
//             });

//             const result = await response.json();

//             if (!response.ok || result.status !== "SUCCESS") {
//                 throw new Error(result.message || "Payment failed");
//             }

//             setPaymentResult(result.data);
//             setStep("success");

//         } catch (err) {
//             setError(err.message);
//             setStep("confirm");
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     // Start Hold
//     const handleMouseDown = (e) => {
//         e.preventDefault();
//         if (!password.length) return;

//         setIsHolding(true);
//         setHoldProgress(0);

//         holdIntervalRef.current = setInterval(() => {
//             setHoldProgress(prev => {
//                 const next = prev + 10;

//                 if (next >= 100) {
//                     clearInterval(holdIntervalRef.current);
//                     setIsHolding(false);

//                     // TRIGGER PAYMENT
//                     handleMakePayment();

//                     return 100;
//                 }

//                 return next;
//             });
//         }, 100);
//     };

//     const handleMouseUpOrLeave = () => {
//         if (holdIntervalRef.current) clearInterval(holdIntervalRef.current);
//         setHoldProgress(0);
//         setIsHolding(false);
//     };

//     useEffect(() => {
//         return () => clearInterval(holdIntervalRef.current);
//     }, []);

//     // -----------------------------
//     // BACK BUTTON LOGIC
//     // -----------------------------
//     const handleBack = () => {
//         if (step === "input") return onBack();
//         if (step === "details") {
//             setSelectedCharge(null);
//             setStep("input");
//         }
//         if (step === "confirm") {
//             setPassword("");
//             setStep("details");
//         }
//         if (step === "success") return onBack();
//     };

//     // -----------------------------
//     // SCREEN RENDER LOGIC
//     // -----------------------------
//     const content = useMemo(() => {
//         if (isLoading) {
//             return (
//                 <div className="flex flex-col items-center justify-center p-10 h-64">
//                     <Loader2 className="w-8 h-8 text-blue-500 animate-spin mb-4" />
//                     <p className="text-gray-600 font-medium">Loading...</p>
//                 </div>
//             );
//         }

//         if (step === "input") {
//             return (
//                 <>
//                     {error && (
//                         <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-xl mb-6">
//                             <p className="font-bold">Error</p>
//                             <p className="text-sm">{error}</p>
//                         </div>
//                     )}

//                     <BillerCard biller={biller} />

//                     <h2 className="text-lg font-semibold text-gray-800 mb-4">Select a Bill No</h2>

//                     {availableCharges.length === 0 ? (
//                         <div className="p-6 text-center text-gray-500 bg-gray-50 rounded-xl">
//                             No services available for this biller.
//                         </div>
//                     ) : (
//                         <div className="space-y-3">
//                             {availableCharges.map(ch => (
//                                 <button
//                                     key={ch.PaymentCode}
//                                     onClick={() => { setSelectedCharge(ch); setStep("details"); }}
//                                     className="w-full p-4 bg-white rounded-xl shadow-sm border border-gray-200 hover:border-blue-500 transition flex justify-between"
//                                 >
//                                     <div>
//                                         <p className="font-semibold text-gray-800">Bill No: {ch.PaymentCode}</p>
//                                         <p className="text-xs text-gray-500 mt-1">{ch.Name}</p>
//                                     </div>
//                                     <ChevronRight className="w-5 h-5 text-blue-500" />
//                                 </button>
//                             ))}
//                         </div>
//                     )}
//                 </>
//             );
//         }

//         if (step === "details") {
//             return (
//                 <>
//                     <BillerCard biller={biller} />
//                     <BillDetailsSection details={selectedCharge} />

//                     <div className="p-4 bg-blue-50 border border-blue-200 text-blue-700 rounded-xl mt-6">
//                         <p className="font-bold">Consumer ID:</p>
//                         <p className="text-sm">{selectedCharge.ConsumerIdField}</p>
//                     </div>
//                 </>
//             );
//         }

//         if (step === "confirm") {
//             const total = parseFloat(selectedCharge.Amount) + parseFloat(selectedCharge.ItemFee);

//             return (
//                 <>
//                     <BillerCard biller={biller} />

//                     <div className="bg-white p-5 rounded-2xl shadow-md mb-6">
//                         <div className="flex justify-between mb-1">
//                             <p className="text-xl font-bold text-red-600">{total.toFixed(2)} NGN</p>
//                             <p className="text-sm font-medium">Due Date</p>
//                         </div>
//                         <p className="text-xs text-red-500">Includes Fee: {selectedCharge.ItemFee} NGN</p>
//                     </div>

//                     <label className="block text-lg font-semibold mb-2">Password</label>
//                     <input
//                         type="password"
//                         className="w-full px-4 py-3 border rounded-xl"
//                         placeholder="Enter your password"
//                         value={password}
//                         onChange={e => setPassword(e.target.value)}
//                     />
//                 </>
//             );
//         }

//         if (step === "success") {
//             return (
//                 <div className="p-5">
//                     <div className="bg-white p-6 rounded-2xl shadow-xl text-center">

//                         <div className="w-20 h-20 mx-auto bg-blue-100 rounded-full flex items-center justify-center mb-4">
//                             <Check className="w-10 h-10 text-blue-600 stroke-[3]" />
//                         </div>

//                         <h2 className="text-2xl font-bold">Payment Successful</h2>
//                         <p className="text-gray-500 mt-1 mb-6">{biller.name}</p>

//                         <div className="space-y-4 pt-4 border-t">
//                             <TransactionRow label="Transaction ID" value={paymentResult.transactionId} />
//                             <TransactionRow label="Amount" value={`${paymentResult.amount} NGN`} />
//                             <TransactionRow label="Charge" value={`${paymentResult.fee} NGN`} />
//                             <TransactionRow label="Total" value={`${paymentResult.totalAmount} NGN`} total />
//                             <TransactionRow label="Timestamp" value={paymentResult.timestamp} />
//                         </div>

//                         <button className="mt-8 text-blue-600 flex mx-auto">
//                             <Download className="w-5 h-5 mr-2" />
//                             Download Invoice
//                         </button>
//                     </div>
//                 </div>
//             );
//         }

//         return null;
//     }, [step, isLoading, selectedCharge, paymentResult, error, password, holdProgress]);

//     // -----------------------------
//     // FOOTER BUTTON
//     // -----------------------------
//     const footerButton = useMemo(() => {
//         if (isLoading) return { disabled: true, text: "Loading..." };

//         if (step === "details") return {
//             text: "Continue to Payment",
//             disabled: false,
//             onClick: () => setStep("confirm")
//         };

//         if (step === "confirm") return {
//             isHold: true,
//             text: isHolding ? `Processing... (${holdProgress}%)` : "Tap & Hold to Confirm",
//             disabled: password.length === 0
//         };

//         if (step === "success") return {
//             text: "Back to Home",
//             disabled: false,
//             onClick: onBack
//         };

//         return { disabled: true, text: "" };
//     }, [step, isLoading, password, isHolding, holdProgress]);

//     // -----------------------------
//     // RENDER
//     // -----------------------------
//     return (
//         <div className="max-w-md mx-auto min-h-screen bg-white shadow-xl flex flex-col rounded-xl">

//             {/* HEADER */}
//             <header className="flex items-center p-4 border-b">
//                 <button
//                     className="text-gray-600"
//                     onClick={handleBack}
//                     disabled={step === "success" || isLoading}
//                 >
//                     <ChevronLeft className="w-6 h-6" />
//                 </button>
//                 <h1 className="flex-grow text-center text-lg font-semibold">Pay Electricity</h1>
//                 <div className="w-6" />
//             </header>

//             {/* MAIN */}
//             <main className={`flex-grow overflow-y-auto p-5`}>
//                 {content}
//             </main>

//             {/* FOOTER */}
//             <div className="fixed bottom-0 inset-x-0 bg-white border-t p-4">
//                 {footerButton.isHold ? (
//                     <div
//                         className={`w-full py-3 rounded-xl text-lg font-semibold text-center relative overflow-hidden
//                             ${footerButton.disabled ? "bg-blue-300" : "bg-blue-600 text-white"}`}
//                         onMouseDown={!footerButton.disabled ? handleMouseDown : undefined}
//                         onMouseUp={!footerButton.disabled ? handleMouseUpOrLeave : undefined}
//                         onMouseLeave={!footerButton.disabled ? handleMouseUpOrLeave : undefined}
//                         onTouchStart={!footerButton.disabled ? handleMouseDown : undefined}
//                         onTouchEnd={!footerButton.disabled ? handleMouseUpOrLeave : undefined}
//                         onTouchCancel={!footerButton.disabled ? handleMouseUpOrLeave : undefined}
//                     >
//                         <div
//                             className="absolute inset-0 bg-blue-800 opacity-40"
//                             style={{ width: `${holdProgress}%` }}
//                         />
//                         <span className="relative z-10">{footerButton.text}</span>
//                     </div>
//                 ) : (
//                     <button
//                         className={`w-full py-3 rounded-xl text-lg font-semibold
//                             ${footerButton.disabled ? "bg-blue-300" : "bg-blue-600 text-white"}`}
//                         onClick={footerButton.onClick}
//                         disabled={footerButton.disabled}
//                     >
//                         {footerButton.text}
//                     </button>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default PayEBillProviderDetails;
